import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsOsmcComponent } from './simple-icons-osmc.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsOsmcComponent ],
    exports:      [ SimpleIconsOsmcComponent ],
    bootstrap:    []
})
export class SimpleIconsOsmcModule {}
